import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  justify-content: center;
  background-color: #e3f2fd;
  height: 100%;
  width: 100%;
  padding-top: 80px;
  padding-bottom: 20px;
  border-radius: 10px;
  margin: auto;
  font-family: Arial, sans-serif;
`;

export const WrapContent = styled.div`
    display: flex;
    flex-direction: column;
    width: 80%;
`

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;

  img{
    width: 120px;
  }
`;

export const Title = styled.h2`
  color: red;
`;

export const InputGroup = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 15px;
`;

export const Input = styled.input`
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  width: 200px;
`;

export const Select = styled.select`
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  width: 200px;
  background: white;
  cursor: pointer;
`;

export const DropdownList = styled.ul`
  position: absolute;
  width: 20%;
  max-height: 150px;
  overflow-y: auto;
  background: white;
  border: 1px solid #ccc;
  list-style: none;
  padding: 0;
  margin: 0;
  z-index: 1000;

  li {
    padding: 10px;
    cursor: pointer;

    &:hover {
      background: #f0f0f0;
    }
  }
`;

export const SearchButton = styled.button`
  background-color: #005CA9;
  border: none;
  cursor: pointer;
  padding: 12px;
  border-radius: 8px;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  background: white;
  border-radius: 5px;
  overflow: hidden;
`;

export const Th = styled.th`
  background-color: #e3f2fd;
  padding: 10px;
  text-align: left;
  border-bottom: 2px solid #ddd;
`;

export const Td = styled.td`
  padding: 10px;
  border-bottom: 1px solid #ddd;
`;

export const Footer = styled.div`
  position: absolute    ;
  margin-top: 10px;
  font-size: 12px;
  text-align: left;
  bottom: 45px;
`;

export const AcceptButton = styled.div`
  display: inline-block;
  transition: transform 0.6s ease-in-out;

  &:hover{
    transform: rotate(-360deg);
  }
`